export default __webpack_public_path__ + "static/media/logo-talis-e.bfdb0f33.png";